<template>
    <button type="button" class="task-audio-btn" @click="$store.dispatch('taskaudio/toggle')">
        <i class="mdi" :class="playing ? 'mdi-volume-off' : 'mdi-volume-high'"></i>
    </button>
</template>

<script>
import { mapGetters } from 'vuex';

// Toggle for the step's background audio, bottom-right over the gallery like the native media button.
// The icon shows the action (volume-off while playing), like the Android app.
export default {
    computed: {
        ...mapGetters('taskaudio', ['playing']),
    },
};
</script>

<style scoped lang="scss">
// same look as the carousel arrows in EspMediaGallery
.task-audio-btn {
    position: absolute;
    right: 15px;
    bottom: 15px;
    width: 40px;
    height: 40px;
    border: none;
    border-radius: 50%;
    background-color: rgba(0, 0, 0, 0.5);
    color: white;
    font-size: 1.5rem;
    line-height: 40px;
    cursor: pointer;
    z-index: 2;
}
</style>
